import { FC } from "react";
import { useSelector } from "react-redux";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import { selectActivationTime, selectDeactivationTime } from "../../../slices/subscriptions-slice";
import CalendarIconSVG from "../../resources/svg/CalendarIconSVG";
import CalendarWithDashIconSVG from "../../resources/svg/CalendarWithDashIconSVG";
import { getNormalizedTimeAndDate } from "../../../tools/DatetimeTools";

const SubscriptionDateTimeBlock: FC = () => {
    const { t } = useTranslation();
    const { upTo1024, moreOrEqual1024 } = useScreenSize();
    const activationTime = useSelector(selectActivationTime);
    const deactivationTime = useSelector(selectDeactivationTime);

    return (
        <>
            {moreOrEqual1024 && (
                <div className="flex items-center bg-[rgba(255,255,255,0.05)] rounded-[9px] h-[64px] dmax2:h-12 px-6 dmax2:px-4 w-fit tmax4:w-full mb-8 dmax2:mb-6">
                    <CalendarIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textWhite mr-3" />
                    <span className="H20 dmax2:H14B text-textWhite mr-5 dmax2:mr-3">
                        {t("subscription.activationDate")}
                    </span>
                    <span className="H20 dmax2:H16B text-textWhite border-r border-r-[rgba(75,75,82,1)] pr-5 mr-5">
                        {getNormalizedTimeAndDate(activationTime)}
                    </span>
                    <CalendarWithDashIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textWhite mr-3" />
                    <span className="H20 dmax2:H14B text-textWhite mr-5 dmax2:mr-3">
                        {t("subscription.deactivationDate")}
                    </span>
                    <span className="H20 dmax2:H16B text-textWhite">{getNormalizedTimeAndDate(deactivationTime)}</span>
                </div>
            )}
            {upTo1024 && (
                <>
                    <div className="flex items-center bg-[rgba(255,255,255,0.05)] rounded-[9px] h-[64px] dmax2:h-12 px-6 dmax2:px-4 w-fit tmax4:w-full mb-8 dmax2:mb-6">
                        <CalendarIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textWhite mr-3" />
                        <span className="H20 dmax2:H14B text-textWhite mr-5 dmax2:mr-3">
                            {t("subscription.activationDate")}
                        </span>
                        <span className="H20 dmax2:H16B text-textWhite">
                            {getNormalizedTimeAndDate(activationTime)}
                        </span>
                    </div>
                    <div className="flex items-center bg-[rgba(255,255,255,0.05)] rounded-[9px] h-[64px] dmax2:h-12 px-6 td4:px-4 tmax4:pl-4 tmax4:pr-0 w-fit tmax4:w-full mb-8 dmax2:mb-6">
                        <CalendarWithDashIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textWhite mr-3" />
                        <span className="H20 dmax2:H14B text-textWhite mr-5 dmax2:mr-3">
                            {t("subscription.deactivationDate")}
                        </span>
                        <span className="H20 dmax2:H16B text-textWhite">
                            {getNormalizedTimeAndDate(deactivationTime)}
                        </span>
                    </div>
                </>
            )}
        </>
    );
};

export default SubscriptionDateTimeBlock;
